import type { FC } from "react";

import { Card, CardRowSimple, type GridCard } from "widgets";

import { NoteTile } from "../../core/tiles/index.js";
import type { EcNumber } from "@/graphql.ts";

// TODO: Add description once available!

export interface IEcNumberListCardProps extends GridCard {
  ecNumbers: EcNumber[];
  ignoreIfEmpty?: boolean;
}

const EcNumberListCard: FC<IEcNumberListCardProps> = (props) => {
  const ecNumbers: EcNumber[] = props.ecNumbers;
  if (!!props.ignoreIfEmpty && (!ecNumbers || ecNumbers.length === 0)) {
    return null;
  }

  let elements: JSX.Element | JSX.Element[] = <>This protein has no E.C. Numbers.</>;

  if (ecNumbers && ecNumbers.length > 0) {
    elements = ecNumbers.map((ecNumber: EcNumber) => {
      return (
        <NoteTile title={ecNumber.name} key={`ec-number-card-elem-${ecNumber.name}`}>
          {ecNumber.description}
        </NoteTile>
      );
    });
  }

  return (
    <Card title={"EC Numbers"} tag={{ label: String(ecNumbers.length) }}>
      <CardRowSimple>{elements}</CardRowSimple>
    </Card>
  );
};

export { EcNumberListCard };
